module.exports = __webpack_public_path__ + "static/28-7cc4a54e03b65dc02c01756d2d997c47.png";